$(document).ready(function() {
	var searchMask = $('#search-field').val();
	$("li.results-item a").each(function(i, element) {
		var content = $(element).text();
		var regEx = new RegExp(searchMask, "gi");

		var result = content.replace(regEx, function(math) {
			return '<span class="search-found">' + math + '</span>';
		});
		$(element).html(result);
	});
});
$('.func-letter').on('click', function(e) {
	e.preventDefault();
	href = $(this).attr('href');
	$('html,body').animate({
		scrollTop: $(href).offset().top - innerHeight / 2
	});
});
if ($('.alphabet-wrapper').length) {

	$(document).on('scroll', function(e) {
		if (scrollY >= $('.alphabet-wrapper').offset().top) {
			$('.header .alphabet').fadeIn();
		} else {
			$('.header .alphabet').fadeOut();
		}
	});
}

if (innerWidth <= 700) {
	sliderColumn()
}

function sliderColumn() {
	$('.instr-content').each(function() {
		var html = $(this).find(".instr-title:not(.init):lt(4)").addClass('init');
		var $slider = $('<div class="slider-item"></div>');
		if (html.length) {
			html.each(function(i, elem) {
				$slider[0].append(elem)
			});
			$(this).append($slider);
		}
	})
	if ($(".instr-title:not(.init)").length) {
		sliderColumn()
	} else {
		$('.instr-content').bxSlider({
			infiniteLoop: false,
			hideControlOnEnd: true,
			pager: false
		})
	}
}
